import React, { useState } from 'react'
import UserService, { IUserModel } from '../../services/user'
import { Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { useDispatch } from 'react-redux'
import { updateSingleUser } from './userSlice'
import { handleRequestError } from '../../services/api'

interface IProps {
    user: IUserModel
}

export default function BlockUserButton(props: IProps) {

    const dispatch = useDispatch()

    const { user } = props
    const [loading, setLoading] = useState<boolean>(false)

    const blockUser = () => {
        setLoading(true)

        UserService.blockUser(user.id, user.is_blocked ? true : false)
            .then(response => {

                const { data } = response
                const message = data.message ? data.message : "User has been blocked"

                updateQuickNotificationDetails(true, message, "success", dispatch)

                dispatch(updateSingleUser({
                    ...user,
                    is_blocked: user.is_blocked ? false : true,
                    status: user.is_blocked ? "active" : "blocked"
                }))

                setLoading(false)

            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoading(false)
            })
    }
    
    return <LoadingButton onClick={() => blockUser()} loading={loading} className="general-button admin-style light-button" variant="contained" color={user.is_blocked ? "success" : "error"} >{user.is_blocked ? "Unblock" : "Block"}</LoadingButton>
}